import * as React from "react";
import { Avatar, AvatarGroup, Grid } from "@mui/material";
import theme from "@theme";
import { stringAvatar } from "./StringFunction";
import Box from "@mui/joy/Box";
import Tooltip from "@mui/joy/Tooltip";
import Typography from "@mui/joy/Typography";
import AdjustIcon from "@mui/icons-material/Adjust";

const GroupAvatars = (props) => {
  const {
    value,
    max = 4,
    height = 23,
    width = 23,
    fontSize = "11px",
    alignItems = "center",
    color = theme.colors.white,
    onClick = () => {},
    zIndex = 2001,
    sx,
    open = false,
  } = props;

  return (
    <AvatarGroup
      onClick={onClick}
      max={max}
      sx={{
        "& .MuiAvatar-root": {
          width: width,
          height: height,
          fontSize: fontSize,
        },
      }}
    >
      {Array.isArray(value) &&
        value.map((data, index) => {
          const avatarProps = stringAvatar(data?.name || "");
          return (
            <Tooltip
              key={index}
              placement="top-end"
              variant="outlined"
              arrow
              sx={{
                zIndex: zIndex,
              }}
              title={
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    maxWidth: 320,
                    justifyContent: "center",
                    marginTop: "-16px",
                  }}
                >
                  <Grid container spacing={1} alignItems="center" mt={1}>
                    <Grid item>
                      <AdjustIcon color="success" />
                    </Grid>
                    <Grid
                      item
                      sx={{ display: "flex", flexDirection: "column" }}
                    >
                      <Typography fontWeight="lg" fontSize="sm">
                        {data?.name || ""}
                      </Typography>
                      <Typography
                        textColor="text.secondary"
                        fontSize="sm"
                        sx={{ mb: 1 }}
                      >
                        {data?.email || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              }
              onClick={(e) => e.stopPropagation()}
            >
              <Avatar
                key={index}
                sx={{
                  height: height,
                  width: width,
                  fontSize: fontSize,
                  color: color,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: alignItems,
                  ...sx,
                  ...avatarProps.sx,
                }}
                onClick={onClick}
              >
                {avatarProps.children}
              </Avatar>
            </Tooltip>
          );
        })}
    </AvatarGroup>
  );
};

export default GroupAvatars;
